import { render, staticRenderFns } from "./ProjectCardNew.vue?vue&type=template&id=21d12282&scoped=true"
import script from "./ProjectCardNew.vue?vue&type=script&lang=ts"
export * from "./ProjectCardNew.vue?vue&type=script&lang=ts"
import style0 from "./ProjectCardNew.vue?vue&type=style&index=0&id=21d12282&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d12282",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d12282')) {
      api.createRecord('21d12282', component.options)
    } else {
      api.reload('21d12282', component.options)
    }
    module.hot.accept("./ProjectCardNew.vue?vue&type=template&id=21d12282&scoped=true", function () {
      api.rerender('21d12282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ProjectCardNew.vue"
export default component.exports